
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sources/metabase",
      function () {
        return require("private-next-pages/sources/metabase.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sources/metabase"])
      });
    }
  